<template>
  <div v-if="result" class="result-ok" :class="rightClassName">
    <CheckSvg :scale="scale" />
  </div>
  <div v-else class="result-wrong" :class="wrongClassName">
    <XSvg :scale="scale" />
  </div>
</template>

<script lang="ts">
import CheckSvg from "@/svg/CheckSvg.vue";
import XSvg from "@/svg/XSvg.vue";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    result: { type: Boolean, default: false },
    rightClassName: {
      type: String,
      default: "tw-absolute tw-top-0 tw-right-0",
    },
    wrongClassName: {
      type: String,
      default: "tw-absolute tw-top-[3px] tw-right-[14px]",
    },
    scale: { type: Number, default: 1 },
  },
  components: { CheckSvg, XSvg },
});
</script>
